function validateRequiredGridBundleProducts() {
  const selectors = document.querySelectorAll(".quantity-selector-bundle");
  const bundleForm = document.getElementById("grid-bundle-form");
  const bundleData = JSON.parse(bundleForm.dataset.bundle);
  const requiredProducts = new Set();
  
  for (let i = 1; i <= 7; i++) {
    const isRequired = bundleData[`product_${i}_required`];
    const productName = `product_${i}`;
    if (isRequired === true) {
      requiredProducts.add(productName);
    }
  }

  let showError = false;
  const errorProductLabels = []; 

  selectors.forEach((selector) => {
    const productName = selector.dataset.productName;
    const productLabel = selector.dataset.productTitle;
    const productValue = selector.querySelector('.quantity-selector__input').value;
    if (requiredProducts.has(productName)) {
      if (productValue !== "1") {
        showError = true;
        errorProductLabels.push(productLabel);
      }
    } else {
      if (productValue !== "0" && productValue !== "1") {
        showError = true;
        errorProductLabels.push(productLabel);
      }
    }
  });

  const errorWrapHtml = document.querySelector(".dropdown-bundle-error");
  const textErrorElement = errorWrapHtml.querySelector(".products-labels");

  if (!showError) {
    errorWrapHtml.classList.add('hidden');
    return true;
  }

  textErrorElement.textContent = errorProductLabels.join(', ');
  errorWrapHtml.classList.remove("hidden");

  return false;
}


function getDataForGridBundle(bundleForm) {
  const bundleProductId = bundleForm.dataset.bundleProductVariantId;
  const quantitySelectors = bundleForm.querySelectorAll(".quantity-selector__input");
  
  const selectedProductIds = [bundleProductId];
  quantitySelectors.forEach((input) => {
    if (input.value === "1" && input.dataset.productRequired) {
      selectedProductIds.push(input.dataset.productVariantId);
    }
  });

  const bundleId = selectedProductIds.join(':');

  const lineItems = [];
  quantitySelectors.forEach((input) => {
    const productVariantId = input.dataset.productVariantId;
    const isRequired = input.dataset.productRequired;
    const quantityValue = parseInt(input.value, 10);
    if (quantityValue === 1) {
      lineItems.push({
        id: productVariantId,
        quantity: quantityValue,
        properties: isRequired && {
          _bundleId: bundleId,
        },
      });
    }
  });

  return lineItems;
}
